module.exports = __webpack_public_path__ + "img/am.5ec15c25.svg";